<template>
  <v-flex
    id="prevDescription"
    class="question mt-5"
  >
    <v-layout
      class="stepper__wrapper text-ce overflow-hidden"
      fill-height
      justify-center
      pa-4
      pt-0
      mb-3
      column
    >
      <h1 class="header">
        {{ customTitle || getSheetDescriptionQuestions.description_preview.label }}
      </h1>

      <v-flex
        v-if="familyList.length > 0"
        xs12
        mt-3
      >
        <h2 class="header sz_dark_grey--text">
          {{ getSheetDescriptionQuestions.family_introduction.label }}
        </h2>
        <div class="content">
          <v-layout
            row
            wrap
            :justify-start="!xsOnly"
            :justify-center="xsOnly"
          >
            <familyAvatar
              v-for="(person, index) in familyList"
              :key="index"
              class="mr-5"
              :person="person"
              :hide-real-names="true"
            />
          </v-layout>
        </div>
      </v-flex>

      <div v-if="getSheetDescriptionQuestions.hasOwnProperty('family_history')">
        <h2 class="header sz_dark_grey--text mt-3 mb-0">
          {{ getSheetDescriptionQuestions.family_history.label }}
        </h2>
        <p
          v-if="getHistory"
          class="f-1 wrap-lines"
        >
          {{ getHistory }}
        </p>
      </div>

      <div v-if="getSheetDescriptionQuestions.hasOwnProperty('family_beauty')">
        <h2 class="header sz_dark_grey--text mt-3 mb-0">
          {{ getSheetDescriptionQuestions.family_beauty.label }}
        </h2>
        <p
          v-if="getBeauty"
          class="f-1 wrap-lines"
        >
          {{ getBeauty }}
        </p>
      </div>

      <div v-if="getSheetDescriptionQuestions.hasOwnProperty('family_everyday_life')">
        <h2 class="header sz_dark_grey--text mt-3 mb-0">
          {{ getSheetDescriptionQuestions.family_everyday_life.label }}
        </h2>
        <p
          v-if="getEverydayLife"
          class="f-1 wrap-lines"
        >
          {{ getEverydayLife }}
        </p>
      </div>

      <div v-if="getSheetDescriptionQuestions.hasOwnProperty('key_needs')">
        <h2 class="header sz_dark_grey--text mb-0 mt-3">
          {{ getSheetDescriptionQuestions.key_needs.label }}
        </h2>
        <div class="pa-3 pt-0">
          <ul class="ul-decimal">
            <li
              v-for="(item, index) in importantNeeds"
              :key="index"
              class="fw-600"
            >
              <span class="f-1">{{ item.need }}</span>
              <p class="f-1 font-weight-regular formatted-text">
                {{ item.note }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </v-layout>
  </v-flex>
</template>

<script>
import familyAvatar from '@/components/widgets/description/familyAvatar';
import { mapGetters } from 'vuex';

export default {
    name: 'PreviewDescription',
    components: { familyAvatar },
    props: {
        customTitle: {
            default: null
        },
        importantNeeds: {
            default: () => {
                return [];
            }
        },
        familyGuide: {
            default: () => {
                return [];
            }
        },
        relationResource: {
            default: () => {
                return [];
            }
        },
        ageResource: {
            default: () => {
                return [];
            }
        },
        changedNames: {
            default: () => {
                return [];
            }
        },
        customHistory: {
            default: null
        },
        customBeauty: {
            default: null
        },
        customEverydayLife: {
            default: null
        },
        customFamilyList: {
            default: null
        }
    },
    computed: {
        ...mapGetters('sheet', ['getSheetDescriptionQuestions']),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        description () {
            return this.$store.getters['description/getDescription'];
        },
        familyList () {
            if (this.customFamilyList != null) {
                return this.customFamilyList;
            }
            const list = [];
            this.familyGuide.representatives.forEach((el) => {
                const tmp = { ...el };

                tmp.relation = this.relationResource.find((el) => {
                    return el.id === tmp.relation;
                });
                if (tmp.relation != null) {
                    tmp.relation = tmp.relation.description;
                }
                tmp.ageOption = this.ageResource.find((el) => {
                    return el.id === tmp.ageOption;
                });
                if (tmp.ageOption != null) {
                    tmp.ageOption = tmp.ageOption.description;
                }

                const changedName = this.changedNames.find((e) => {
                    return e.id === el.id;
                });
                if (changedName) {
                    list.push({ ...tmp, changedName: changedName.newName });
                }
            });

            return list;
        },
        getHistory () {
            if (this.customHistory == null) {
                return this.description.familyHistory;
            }
            return this.customHistory;
        },
        getBeauty () {
            if (this.customBeauty == null) {
                return this.description.familyBeauty;
            }
            return this.customBeauty;
        },
        getEverydayLife () {
            if (this.customEverydayLife == null) {
                return this.description.familyEverydayLife;
            }
            return this.customEverydayLife;
        }
    }
};
</script>

<style lang="scss" scoped>
.wrap-lines {
  white-space: pre-line;
}
</style>
